<template>
  <el-row>
    <div id="toolbar" style="text-align: right;">
      <el-form :model="sk" name="searchForm" ref="searchForm" inline>
        <el-form-item label="邮箱地址" prop="email">
          <el-input v-model="sk.email" placeholder="请输入邮箱地址"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="getBuyers(1)"><i class="fa fa-search"></i>买家搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
     <el-table v-loading="pageloading" element-loading-text="拼命加载中..." element-loading-spinner="el-icon-loading" :data="buyers" stripe>
       <el-table-column label="头像" width="100" align="center">
         <template slot-scope="d">
           <div style="height: 68px; width: 68px;">
             <img :src="d.row.cover" v-if="d.row.cover" style="object-fit: cover; width: 68px; border-radius: 34px;"/>
             <i class="fa fa-user" style="width: 68px; height: 68px; border-radius: 68px; text-align: center; font-size: 32px; vertical-align: center; background-color: rgb(226,226,226)"></i>
           </div>
         </template>
       </el-table-column>
       <el-table-column prop="ID" label="买家编号" width="100px;"></el-table-column>
       <el-table-column label="姓名">
         <template slot-scope="d">
           {{d.row.firstName}} {{d.row.lastName}}
         </template>
       </el-table-column>
       <el-table-column prop="email" label="用户邮箱"></el-table-column>
       <el-table-column label="评论操作" align="right" width="110">
          <template slot-scope="d">
            <el-button size="mini" type="text">用户编辑</el-button>
            <el-button size="mini" type="text">禁用买家</el-button>
          </template>
        </el-table-column>
     </el-table>
    <el-row>
      <el-pagination
        @current-change="getBuyers"
        :current-page="currPage.page"
        :page-sizes="[15]"
        :page-size="15"
        layout="total, sizes, prev, pager, next, jumper"
        :total="currPage.total">
      </el-pagination>
    </el-row>
  </el-row>
</template>

<script>
export default {
  name: 'Buyer',
  data () {
    return {
      sk: {},
      buyers: [],
      currPage: {page: 1, total: 0},
      tableloading: false
    }
  },
  mounted () {
    this.getBuyers(1)
  },
  methods: {
    getBuyers: function (page) {
      var para = {}
      para.method = 'shop.buyerpage'
      para.sk = this.sk
      var that = this
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.buyers = ret.body.data.comtents
        that.currPage.total = ret.body.data.total
        that.currPage.page = page
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/order/Buyer.vue